import { l as O } from "../../../_virtual/leaflet-src.js";
import p, { forwardRef as R, useState as i, useImperativeHandle as _, useCallback as b, useEffect as j } from "react";
import { createLeafletContext as x, LeafletProvider as L } from "../../@react-leaflet/core/lib/context.js";
function o() {
  return o = Object.assign || function(n) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var l in t)
        Object.prototype.hasOwnProperty.call(t, l) && (n[l] = t[l]);
    }
    return n;
  }, o.apply(this, arguments);
}
function P({ bounds: n, boundsOptions: r, center: t, children: l, className: m, id: c, placeholder: v, style: C, whenReady: f, zoom: s, ...d }, g) {
  const [w] = i({
    className: m,
    id: c,
    style: C
  }), [e, E] = i(null);
  _(g, () => (e == null ? void 0 : e.map) ?? null, [
    e
  ]);
  const h = b((u) => {
    if (u !== null && e === null) {
      const a = new O.Map(u, d);
      t != null && s != null ? a.setView(t, s) : n != null && a.fitBounds(n, r), f != null && a.whenReady(f), E(x(a));
    }
  }, []);
  j(() => () => {
    e == null || e.map.remove();
  }, [
    e
  ]);
  const M = e ? /* @__PURE__ */ p.createElement(L, {
    value: e
  }, l) : v ?? null;
  return /* @__PURE__ */ p.createElement("div", o({}, w, {
    ref: h
  }), M);
}
const H = /* @__PURE__ */ R(P);
export {
  H as MapContainer
};
